import { growthbookConfig } from "ENV";
import { GrowthBook, Result } from '@growthbook/growthbook';
import CookieHelper from '../CookieHelper/CookieHelper';
import DataLayerHelper from '../tagManager/DataLayerHelper';

class GrowthBookHelper {
  public gb: GrowthBook;

  public lastResult: Result<any> | null = null;

  public constructor() {
    this.gb = new GrowthBook({
      apiHost: growthbookConfig.cl.apiUrl,
      clientKey: growthbookConfig.cl.clientKey,
      enableDevMode: process.env.NODE_ENV === 'development',
      subscribeToChanges: false,
      trackingCallback: (experiment, result) => {
        console.log('### result ###', result);
        this.lastResult = result;
        DataLayerHelper.pushEvent('af_experiment_experience', {
          experiment_id: experiment.key,
          variant_id: result.key,
          variant_value: result.value,
        });
        console.log('Experiment Viewed growthbook:', {
          experimentId: experiment.key,
          variationId: result.key,
          variationValue: result.value,
        });
      },
    });
    this.initiateGrowthBook();
  }

  public async initiateGrowthBook() {
    await this.gb.loadFeatures();
    this.updateGrowthBookURL();
  }

  public async updateGrowthBookURL() {
    this.gb.getExperiments
    this.gb.setAttributes({
      id: CookieHelper.getUserAutofactId(),
      URL: document.URL,
    });
    // https://github.com/growthbook/examples/blob/08ff5c05c26d57665736787a6faa0e0e838239da/next-js/pages/_app.tsx#L34
    this.gb.setURL(document.URL); // esta funcion actualiza la URL experimentos
  }

  public getLastResult(): Result<any> | null {
    return this.lastResult;
  }

}

export default new GrowthBookHelper();
